import { Component } from '@angular/core';

@Component({
  selector: 'app-home-testimonial-section',
  standalone: true,
  templateUrl: './testimonial-section.component.html'
})
export class TestimonialSectionComponent {}
